/* @flow strict */

import * as React from 'react';
import { mockData } from './mock';
import { currency } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  header: string,
  color: string,
  ticketBreak?: boolean,
  tickets: any,
  disabled?: boolean,
  donationsRevenueStatistics: any,
  ticketsRevenueStatistics: any,
  donationGoal?: number,
  isNoStatistic: boolean
};

const EventPageDetailStatsProgressCard = ({
  header,
  color,
  ticketBreak,
  ticketsRevenueStatistics,
  donationsRevenueStatistics,
  tickets,
  disabled,
  donationGoal,
  isNoStatistic
}: PropsType): React.Element<'div'> => {
  const [dataRevenue, setDataRevenue] = React.useState(ticketsRevenueStatistics);
  const [dataDonation, setDataDonation] = React.useState(donationsRevenueStatistics);

  const onSort = (data: any, type: string, set: () => void, up: boolean) => {
     const sorted = [...data].sort((a: any, b: any) => {
         if (up) {
           return a[type] > b[type] ? 1 : -1;
         }
           return a[type] > b[type] ? -1 : 1;
       }
     );

    set(sorted);
  };

  const handleSortRevenue = (type: string, up: boolean): void => onSort(dataRevenue, type, setDataRevenue, up);
  const handleSortDonation = (type: string, up: boolean): void => onSort(dataDonation, type, setDataDonation, up);

  return (
      <div className={`panel panel-default panel-chart ${disabled ? 'disabled' : ''}`}>
        <div className="panel-heading">
          <div className="panel-heading-title">
            {header}
          </div>
          {ticketBreak &&
            <div className="panel-heading-sort">
              Sort by name:&nbsp;
              <button
                className="panel-heading-sort-btn panel-heading-sort-up"
                onClick={(): void => ticketBreak ?
                  handleSortRevenue('ticket_name', true)
                  :
                  handleSortDonation('ticket_name', true)
              }
              />
              <button
                className="panel-heading-sort-btn panel-heading-sort-down"
                onClick={(): void => ticketBreak ?
                  handleSortRevenue('ticket_name', false)
                  :
                  handleSortDonation('ticket_name', true)
              }
              />
            </div>
          }
        </div>

        <div className="panel-body" style={{ minHeight: '260px' }}>
          {ticketBreak ?
            _.map(isNoStatistic ? mockData.TicketsRevenue : dataRevenue, (ip: {}, ipk: number): React.Element<'div'> => {
              const stock_quantity = isNoStatistic ? ip.stock_quantity : (tickets.find(x => x.id === ip.ticket_id)?.stock_quantity || 0);

              return (
                <div className="progress-item" key={`progress-item-${ipk}`}>
                  <h3>{ip.ticket_name}</h3>
                  <div className="progress">
                    <div
                      className={`progress-bar ${color}`}
                      style={{
                        width: `${(ip.sold_quantity - ip.return_quantity) / stock_quantity * 100}%`
                      }}
                    />
                  </div>
                  <div className="progress-text">
                    <span>
                      <span className="symbol">{!ticketBreak ? 'Total Donation:' : ''} {currency[ip.currency || 'USD']}</span>
                      <span className="amount">{(ip.merchant_revenue - ip.merchant_revenue_refund) / 100}</span>
                    </span>
                    <div className="pull-right">
                      {ip.sold_quantity - ip.return_quantity} / {stock_quantity}
                    </div>
                  </div>
                </div>
              );
            })
          :
            _.map(isNoStatistic ? mockData.TicketsDonation : dataDonation, (ip: {}, ipk: number): React.Element<'div'> => {
              const goal = isNoStatistic ? ip.donationGoal : donationGoal;

              return (
                <div className="progress-item" key={`progress-item-${ipk}`}>
                  <h3>Ticket Donation</h3>
                  <div className="progress">
                    <div
                      className={`progress-bar ${color}`}
                      style={{
                        width: `${(ip.amount - ip.amount_refund) / goal * 100}%`
                      }}
                    />
                  </div>
                  <div className="progress-text">
                    <span>
                      <span className="symbol">Total Donation: {currency[ip.currency || 'USD']}</span>
                      <span className="amount">{(ip.amount - ip.amount_refund) / 100}</span>
                    </span>
                    <div className="pull-right">
                      Net Pay: {currency[ip.currency || 'USD']}{(ip.merchant_revenue - ip.merchant_revenue_refund) / 100}
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
  );
};

export default EventPageDetailStatsProgressCard;
